import React from 'react';

import {Stack, Skeleton} from 'views/components';

const SmallSkeleton = () => {
  return (
    <Stack spacing={2} height={'100%'}>
      <Stack spacing={.5} height={'33%'}>
        <Skeleton variant="rounded" height={'30%'} width={'40%'}/>
        <Skeleton variant="rounded" height={'70%'}/>
      </Stack>
      <Stack spacing={.5} height={'33%'}>
        <Skeleton variant="rounded" height={'30%'} width={'40%'}/>
        <Skeleton variant="rounded" height={'70%'}/>
      </Stack>
      <Stack spacing={.5} height={'33%'}>
        <Skeleton variant="rounded" height={'30%'} width={'40%'}/>
        <Skeleton variant="rounded" height={'70%'}/>
      </Stack>
    </Stack>
  );
};


export default React.memo(SmallSkeleton);
